export default __webpack_public_path__ + "static/media/FR-logo-icon.3c173dac.svg";